module.exports = {"linkMap":{"intro":{"text":"Intro","link":"/intro"},"team":{"text":"Team","link":"/team"},"case":{"text":"Case","link":"/case"},"contact":{"text":"Contact","link":"/contact"}},"langList":[{"text":"中文","locale":"zh"}],"address":"5F No.31, Ln. 21, Sec. 6, Minquan E. Rd., Neihu Dist., Taipei City 11490, Taiwan (R.O.C.)","tel":"","email":"min.teai@msa.hinet.net","comName":"Minteai, Inc","sexyoung":"Sexyoung inc"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/locale/en.json
// module id = 569
// module chunks = 0